import { InjectionToken } from '@angular/core';

export const STADIA_MAPS_SERVICE_API_KEY = new InjectionToken<string>(
  'STADIA_MAPS_SERVICE_API_KEY',
);
